import React, { useState, useMemo , useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ShimmerTable } from "react-shimmer-effects";
import {setinternaltable_dashboard} from "../../../../../Redux/Slice"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import boximg from "../../../../../Assets/AppComponent/Group 427320177.svg"


export const Internal_dashboardTable = (props) => {
    const {

     
        range, 
        datas,
        date,
        status,
        priority,
        department
    } = props;
    const dashboardData = useSelector((state) => state.internaltable_dashbaord.Internal_Table_dashboard_);

    const state = useSelector((state) => state);
     const dispatch = useDispatch();
    const [sno, setsno] = useState(0);
    const tableHeaderStyle = {
        padding: "10px",
        fontWeight: "500",
        background: "#f79c37",
        color: "#fff",
                 position: "sticky",
        top: 0,
        zIndex: 2
    };


    useEffect(()=>{
        if(state.ClientBranchIDs.SUBROLE == 3){
         const payload ={
                state: datas.state,
                region: datas.region,
                zone: datas.zone,
                department:department,
                date:date,
                priority:priority,
    
              

         }
         dispatch(setinternaltable_dashboard(payload))
}
    },[datas    ,department  ,priority , date, ])
    const tableHeaderStyleFirst = {
        padding: "10px",
        fontWeight: "500",
        background: "#f79c37",
        color: "#fff",
        borderRadius: "10px 0px 0px 10px",
                 position: "sticky",
        top: 0,
        zIndex: 2

    };

    const tableHeaderStyleLast = {
        padding: "10px",
        fontWeight: "500",
        background: "#f79c37",
        color: "#fff",
        borderRadius: "0px 10px 10px 0px"

    };

    const tableCellStyle = {
        padding: "10px",
        borderBottom: "1px solid #ccc",
        fontSize: "12px",
        textAlign: "left"
    };
       const tableCellStyle_others = {
        padding: "10px",
        borderBottom: "1px solid #ccc",
        fontSize: "12px",
        textAlign: "left",
        paddingLeft: "54px",
    };
    const tableCellStyleno = {
        padding: "10px",
        borderBottom: "1px solid #ccc",
        fontSize: "12px",
        textAlign: "center"
    };
   

  
  const HandleTheExports = () => {
  const excelData = dashboardData.map((item, index) => ({
    "S.NO": index + 1,
    "Category": item.internal_category_id__issue_category_id__name || "",
    "Open Tickets": item.open_tickets || 0,
     "In Progress Tickets": item.inprogress_tickets || 0,
    "Reviewed Tickets": item.review_tickets || 0,
    "Reopened Tickets": item.reopened_tickets || 0,
    "Resolved Tickets": item.resolved_tickets || 0,
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Internal Support");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0]; 

  const fileName = `Internal_support_${formattedDate}.xlsx`;
  saveAs(dataBlob, fileName);
};



    return (
        <>

            <>
                <div style={{ background: "#fff", display: "flex", width: "100%", flexDirection: "column", gap: '10px', padding: "19px", borderRadius: "8px", marginBottom:"30px"}}>

                    <div style={{display: "flex" , justifyContent:"space-between"}}>
                        <div>
    <h4>{"Category-Based Tickets"}</h4>
    </div>

{dashboardData.length > 0&& (

                                <div className="" >
                                    <button
                                        align="center"
                                        type="button"
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            background: "transparent",
                                        }}
                                        className="DownloadBTNS"
                                        onClick={(e) => {
                                            HandleTheExports()
                                        }}
                                    >
                                        <a class="dnbtn"></a>
                                    </button>

                                </div>
)}

                    </div>
                    <div className="NormalTableCalls" style={{ height: "437px", overflowY: "auto", overflowX: "auto", width: "100%", background: "#fff", paddingRight: "12px" }}>
                        <table className="TicketingTableOverviewsDashboard EmployeeTableOverviewsDashboard" style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", minWidth: "1000px" }}>
                            <thead >
                                <tr>
                                    <th style={tableHeaderStyleFirst}>S.NO</th>
                                    <th style={tableHeaderStyle}>Category</th>
                                    <th style={tableHeaderStyle}>Open Tickets</th>
                                                                        <th style={tableHeaderStyle}>In Progress Tickets</th>

                                    <th style={tableHeaderStyle}>Reviewed Tickets</th>
                                    <th style={tableHeaderStyle}>Reopened Tickets</th>
                                    <th style={tableHeaderStyle}>Resolved Tickets</th>
                                  
                                </tr>
                            </thead>





                            {state.EmployeeVerificationsNeed.Internal_dashboard_Bool ?
                                <>
                                    <tbody className="tbodyReact">

                                        <div className="TableLoader"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                width: "100%", // Ensures it spans the full table width
                                                transform: "translate(-50%, -50%)",
                                            }}

                                        >
                                            <ShimmerTable
                                                row={4}
                                                col={9}
                                                style={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                }}
                                            />
                                        </div>
                                    </tbody>
                                </>
                                :

                                <>


                                    {dashboardData.length > 0 ?
                                        <tbody>
                                            {dashboardData.map((item, index) => (
                                                <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
                                                    <td style={tableCellStyle} className="LabelNamesstate">{Number(sno + index + 1)}</td>
                                                    <td style={tableCellStyle}> {`${item.internal_category_id__issue_category_id__name}`}</td>
                                                    <td style={tableCellStyle_others}>{item.open_tickets || "0"}</td>
                                                     <td style={tableCellStyle_others}>{item.inprogress_tickets || "0"}</td>
                                                    <td style={tableCellStyle_others}>{item.review_tickets || "0"}</td>
                                                    <td style={tableCellStyle_others}>{item.reopened_tickets || "0"}</td>
                                                    <td style={tableCellStyle_others}>{item.resolved_tickets ? item.resolved_tickets : "0"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr key={0} style={{ borderBottom: "1px solid #ccc" }}>
                                                                                                <td colSpan="9" style={tableCellStyleno}>
                                                                                    

                                                                                            <div className="Dusbinback">

                                                            <div>
                                                                <img src={boximg} />
                                                                <p className="text-center">{"No Data Available"}</p>

                                                            </div>

                                                            </div>
                                                                            
                                                                                                </td>

                                            </tr>
                                        </tbody>
                                    }                         </>
                            }

                        </table>

                    </div>

              


                </div>
            </>



        </>
    )
}

